import { DirectoryAddContact } from "domains/directory/components/DirectoryAddContact/DirectoryAddContact";
import { DirectoryEditContact } from "domains/directory/components/DirectoryEditContact/DirectoryEditContact";
import { DirectorySearch } from "domains/directory/components/DirectorySearch/DirectorySearch";
import { useDirectory } from "domains/directory/context/DirectoryProvider";

export const DirectoryContent = () => {
    const { view, selectedContactId } = useDirectory();

    if (view === "AddContact") {
        return <DirectoryAddContact />;
    }

    if (view === "EditContact" && selectedContactId) {
        return <DirectoryEditContact contactId={selectedContactId} />;
    }

    return <DirectorySearch />;
};
